import CollectorsType from './components/CollectorsType';
export default CollectorsType;